export default __webpack_public_path__ + "static/media/CommeSi.46d38d24.jpg";